module.exports = true;


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/modules/_library.js
// module id = 242
// module chunks = 48 49 50